import React, { Fragment } from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import {
  PageHeader,
  SimpleDataTable,
  Section,
  DangerousWrapper,
  makeBreadcrumb,
  ListingTable,
  slugify,
  GatsbyLink
} from '@budget-monorepo/shared-ui';

import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';
import PlanFilter from '../components/PlanFilter';

const PlanItem = (props) => {
  const { data, location } = props;
  const { content, site } = data;
  const {
    govLevelOne, govLevelTwo, govLevelTwoDisplay, planItemNumber, planItemName, parent: { parent }
  } = content;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = parent;
  const path = location.pathname;
  const pathPrefix = process.env.GATSBY_PATH_PREFIX;
  const relPath = path.replace(pathPrefix, '');
  const { pageTitle, breadcrumbprops } = makeBreadcrumb({
    href: '/beneficiary-agency',
    text: 'Plan by Beneficiary Agency',
    sections: govLevelOne === govLevelTwo ? [govLevelOne, planItemNumber] : [govLevelOne, govLevelTwo, planItemNumber]
  });
  const layoutProps = {
    activeIndex: 1,
    pre: () => <PlanFilter path={relPath} />,
    above: () => <PageHeader category={planItemNumber} title={`${planItemName}`} />,
    pageTitle,
    breadcrumbprops,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime,
    containerClasses: 'main-content main-content--two'
  };
  const listingProps = {
    rows: [
      {
        label: 'Policy Area',
        items: [
          <GatsbyLink to={`/policy-area/${slugify(content.policyArea)}`}>{content.policyArea}</GatsbyLink>
        ]
      },
      {
        label: 'Capital Agency',
        items: [
          <GatsbyLink to={`/capital-agency/${slugify(content.capitalAgency)}`}>{content.capitalAgency}</GatsbyLink>
        ]
      },
      {
        label: 'Beneficiary Agency',
        items: [
          <GatsbyLink to={breadcrumbprops[2].href}>{govLevelTwoDisplay}</GatsbyLink>
        ]
      },
      {
        label: 'Location',
        items: [
          content.location.join(', ')
        ]
      }
    ]
  };
  // metadata for the page
  const metaTitle = `${content.planItemNumber}: ${content.planItemName}`;
  const metaDescription = `Capital investment plan for item ${metaTitle}.`;
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        <Section>
          {content.planItemLanguage && <DangerousWrapper rawHtml={content.planItemLanguage} htmlTag="p" />}
          {content.planItemTable
          && (
          <React.Fragment>
            <SimpleDataTable title={`${planItemName} ${planItemNumber}`} table={content.planItemTable} maxColWidth={100} download={location.pathname} />
          </React.Fragment>
          )
          }
          <div className="page-content">
            <ListingTable {...listingProps} />
          </div>
        </Section>
      </Layout>
    </Fragment>
  );
};

PlanItem.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
  location: PropTypes.object
};

export default PlanItem;

export const query = graphql`
  query($slug: String!) {
    site {
      ...SiteMetadata
    }
    content: planItem(fields: { slug: { eq: $slug } }) {
      planItemNumber
      planItemName
      planItemLanguage
      govLevelOne
      govLevelTwo
      govLevelTwoDisplay
      capitalAgency
      policyArea
      location
      planItemTable {
        headers {
          name
          type
          align
          value
        }
        data {
          year
          stateBondCap
          nonBondCap
          operatingFunds
          federalFunds
          otherFunds
          total
        }
      }
      # Get the last modified timestamp for the file powering the plan item pages
      ...PlanItemDataTimeStamp
    }
  }
`;
